/**
 * Created by r4zi4l on 17.07.2026
 */

const PrefabEditorScene = cc.Scene.extend({
    ctor: function (target) {
        this._super();

        this.target = target;

        this.sceneComponent = ComponentMap.attach(this, new SceneComponent({
            sceneName: "prefabeditor",
            bundles: [],
            audioStyles: { res: undefined },
            noMenuBar: true
        }));
    },

    onSceneLoaded: function () {
        cleverapps.debugStats.setEnabled(false);

        if (this.target) {
            this.showPrefab(this.target);
        }
    },

    showPrefab: function (target) {
        cleverapps.prefabEditor.createPrefab(target);
    },

    onResize: function () {
        this.sceneComponent.removeFilmEffect();
        this.sceneComponent.onResizeWhileNotLoaded();

        cleverapps.prefabEditor.transformCamera({ reset: true });
        cleverapps.prefabEditor.refreshSelection();
        cleverapps.prefabEditor.refreshCurrentNode();
    },

    onCloseAction: function () {
        return true;
    }
});
